import { Container, Row, Col } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

interface LinkWithIcon {
  text: string
  url: string
  rel?: string
  icon?: string
}

function FooterNew() {
  const { t } = useTranslation()
  const footer: { title: string; links: LinkWithIcon[] }[] = [
    {
      title: 'HomeAuctions',
      links: [
        { text: t('home'), url: '/' },
        { text: t('auctions'), url: '/auctions' },
        { text: t('posts'), url: '/posts' },
        { text: t('services'), url: '/services' },
        { text: t('favorites'), url: '/favorites' },
      ],
    },
    {
      title: 'Help & Support',
      links: [
        { text: t('FAQ'), url: '/faq' },
        { text: t('Impressum'), url: '/impressum' },
        { text: t('AGB'), url: '/agb' },
        { text: t('Datenschutzrichtlinien'), url: '/datenschutzrichtlinien' },
      ],
    },
    {
      title: t('social_media'),
      links: [
        { text: 'Facebook', url: '/', rel: 'nofollow', icon: 'fa-facebook' },
        { text: 'Twitter', url: '/', rel: 'nofollow', icon: 'fa-twitter' },
        { text: 'Instagram', url: '/', rel: 'nofollow', icon: 'fa-instagram' },
        { text: 'Youtube', url: '/', rel: 'nofollow', icon: 'fa-youtube' },
      ],
    },
  ]

  return (
    <Container fluid className='footer-container'>
      <div className='footer-clean'>
        <footer className='footer'>
          <Container fluid>
            <Row>
              {footer.map((item, index) => (
                <Col md={3} className='item' key={index}>
                  <h3>{item.title}</h3>
                  <ul>
                    {item.links.map((link, index) => (
                      <li key={index}>
                        <Link rel={link.rel} to={link.url}>
                          {'icon' in link && <i className={`fa-brands ${link.icon}`} />} {link.text}
                        </Link>
                      </li>
                    ))}
                  </ul>
                  <ul />
                </Col>
              ))}
              <Col md={2} className='item'>
                <ul className='payment-icons-container'>
                  <h3>{t('payment_methods')}</h3>
                  <li className='payment-icons'>
                    <i className='fa-brands fa-paypal' />
                    <i className='fa-brands fa-cc-mastercard' />
                    <i className='fa-brands fa-cc-visa' />
                    <i className='fa-brands fa-cc-amex' />
                  </li>
                </ul>
              </Col>
              <div className='item'>
                <p className='copy-right'>
                {t('footer_copyright', {year: new Date().getFullYear()})}
                </p>
              </div>
            </Row>
          </Container>
        </footer>
      </div>
    </Container>
  )
}

export default FooterNew
